import { QueryClient } from '@tanstack/react-query';

/** List/table data stays fresh for navigation without refetching on every mount. */
export const LIST_STALE_TIME = 5 * 60 * 1000;

/** Keep unmounted page data in memory for quick back-navigation. */
export const LIST_GC_TIME = 30 * 60 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: LIST_STALE_TIME,
      gcTime: LIST_GC_TIME,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
